<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
          <span class="material-icons text-blue-2" style="font-size: 77px">
            account_circle
          </span>
          <h5 class="modal-title">
            Su sesión está a punto de expirar. Desea extender la sesión y seguir
            navegando?
          </h5>
        </div>
        <div class="p-3 text-center">
          <p v-show="!isLoad">
            <span class="btn btn-danger mx-1" @click="handleLogout">Salir</span>
            <span class="btn btn-treid mx-1" @click="handleExtendSesion"
              >Extender</span
            >
          </p>
          <p v-show="isLoad">
            <span class="btn btn-treid mx-1">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Extendiendo...
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../tools/Api2";
import { mapMutations } from "vuex";
export default {
  name: "ModalRefreshToken",
  data() {
    return {
      visible: false,
      isLoad: false,
    };
  },
  created: function () {
    setTimeout(() => {
      this.visible = true;
    }, 13 * 60 * 1000);
  },
  methods: {
    ...mapMutations(["deleteAuth"]),
    handleLogout() {
      this.deleteAuth();
      this.$route.path !== "/" ? this.$router.push("/") : false;
    },
    handleExtendSesion() {
      this.isLoad = true;
      Api("login")
        .get("extend-session")
        .then(() => {
          this.visible = false;
          this.isLoad = false;
          setTimeout(() => {
            this.visible = true;
          }, 13 * 60 * 1000);
        });
    },
  },
};
</script>
<style lang="css" scoped>
</style>